module.exports = __webpack_public_path__ + "img/small.4e2a1923.jpg";